import { render, staticRenderFns } from "./instock_dialog.vue?vue&type=template&id=2b62fc20"
import script from "./instock_dialog.vue?vue&type=script&lang=js"
export * from "./instock_dialog.vue?vue&type=script&lang=js"
import style0 from "./instock_dialog.vue?vue&type=style&index=0&id=2b62fc20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports